module.exports = __webpack_public_path__ + "is.svg?f7d836be7fd4b4798aa1da86b0f6a854";